import React, { FunctionComponent } from 'react';
import ctx from 'classnames';

import styles from './chip.module.scss';

interface CategoryChipProp {
    categoryName: string,
    className?: string,
    isMobile: boolean,
}

export const CategoryChip: FunctionComponent<CategoryChipProp> = ({ categoryName, className, isMobile }) => {
    return <span className={ctx(styles.chip, className, {[styles.isMobile]: isMobile})}>{categoryName}</span>;
};